import Api from '@/api'
const resource = 'transactions'

export default {
  fetchTransactionCategories () {
    return Api.get(`/${resource}/categories`)
  },

  updateTransaction (id, data) {
    return Api.put(`/${resource}/${id}`, { transaction: data })
  }
}
